import { invalidateLocationQueries } from '@/lib/locations/invalidate';
import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';
import type { Estimate, CreateEstimateDto } from '@/types/estimate';

/**
 * Creates a new estimate via the operations microservice.
 */
export const useCreateEstimate = createMutationHook<Estimate, CreateEstimateDto>({
  mutationFn: (dto) =>
    apiPost<Estimate, CreateEstimateDto>(operationsClient, opsEstimateEndpoints.create(), dto),
  onSuccess: (_data, _variables, queryClient) => {
    // A typed service address is saved to the customer as a location on the
    // server, so this save may have created one. See `invalidateLocationQueries`.
    invalidateLocationQueries(queryClient, (_data as { contactId?: string | null }).contactId);
    void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
    toast.success('Estimate created');
  },
});
